import type { JSX } from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useUiStore } from '@/stores/ui'
import { Dialog } from '@/components/ui/Dialog'

/** Шпаргалка по клавишам, вызывается `?` (docs/10 §6). */
export function ShortcutsDialog(): JSX.Element {
  const { t } = useTranslation()
  const open = useUiStore(state => state.shortcutsOpen)
  const setOpen = useUiStore(state => state.setShortcutsOpen)

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      const target = event.target
      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement
      ) {
        return
      }
      if (event.key === '?') {
        event.preventDefault()
        setOpen(true)
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [setOpen])

  return (
    <Dialog open={open} onClose={() => setOpen(false)} title={t('shortcuts.title')} size="sm">
      <ul className="flex flex-col gap-2 text-base text-fg-muted">
        {(['jk', 'enter', 's', 'slash', 'question'] as const).map(key => (
          <li key={key} className="font-mono text-xs">
            {t(`shortcuts.list.${key}`)}
          </li>
        ))}
      </ul>
    </Dialog>
  )
}
